<template>
  <transition name="fade">
    <div class="advance-search-container" v-show="status">
      <div class="advance-search-wrapper">
        <div class="advance-search-header">
          <div class="column100 flex-space-between items-center">
            <div class="advance-search-header__icon">
              <img
                :src="require('~/assets/img/icons/advance-search-grey.png')"
                alt=""
              />
            </div>
            <div
              class="advance-search-header__btn-close cursor-pointer"
              @click="onClose"
            >
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
          <div>
            <div class="gray900 text-bold text-18">Advance Search</div>
            <div class="gray600 text-14">
              Tuliskan detail pencarian untuk mendapatkan hasil terbaik
            </div>
          </div>
        </div>
        <div class="advance-search-content text-14">
          <Input
            :title="'Nama Perusahaan'"
            :placeholder="'Tuliskan nama perusahaan ...'"
            v-model="vendorName"
            :model="vendorName"
          />

          <div class="w-full">
            <div>
              <InputIcons
                :title="'Sub Kegiatan Usaha Utama'"
                :placeholder="'Pilih sub kegiatan usaha utama ...'"
                :disabled="true"
                :onClick="openKbliModal"
              />
            </div>
            <ResultBar
              :data="choosedKbli"
              :desc="'desc'"
              :onClick="id => kbliRemove(id)"
              v-if="choosedKbli.length > 0"
            />
          </div>

          <InputIcons
            :title="'Lokasi'"
            :placeholder="'Tulis Kota / Provinsi / Negara'"
            v-model="location"
            :model="location"
          />

          <div class="col-wrapper">
            <FilterSio
              :topClass="'col-wrapper__per-col'"
              :className="'flex-row items-center gap8'"
            />
            <FilterPertambangan
              :topClass="'col-wrapper__per-col'"
              :className="'flex-row items-center gap8'"
            />
          </div>
          <FilterK3l
            :topClass="'column100'"
            :className="'k3l-filter-wrapper'"
          />
          <FilterKplh
            :topClass="'column100'"
            :className="'flex-row items-center gap24'"
          />

          <div class="col-wrapper">
            <div class="col-wrapper__per-col">
              <div class="w-full mb16">
                <InputIcons
                  :title="'Klasifikasi IUJP'"
                  :placeholder="'Cari klasifikasi IUJP'"
                  :disabled="true"
                  :onClick="openIujpModal"
                  :iconDisable="true"
                />
              </div>
              <ResultBar
                :data="choosedIujp"
                :desc="'sub_bidang'"
                :onClick="id => iujpRemove(id)"
                v-if="choosedIujp.length > 0"
              />
            </div>

            <div class="col-wrapper__per-col">
              <div class="w-full mb16">
                <InputIcons
                  :title="'Klasifikasi SBUJK'"
                  :placeholder="'Cari klasifikasi SBUJK'"
                  :disabled="true"
                  :onClick="openSbujkModal"
                  :iconDisable="true"
                />
              </div>
              <ResultBar
                :data="choosedSbujk"
                :desc="'sub_klasifikasi'"
                :onClick="id => sbujkRemove(id)"
                v-if="choosedSbujk.length > 0"
              />
            </div>
          </div>
          <div class="col-wrapper">
            <div class="col-wrapper__per-col">
              <div class="w-full mb16">
                <InputIcons
                  :title="'Klasifikasi IUJPTL'"
                  :placeholder="'Cari klasifikasi IUJPTL'"
                  :disabled="true"
                  :onClick="openIujptlModal"
                  :iconDisable="true"
                />
              </div>
              <ResultBar
                :data="choosedIujptl"
                :desc="'sub_bidang'"
                :onClick="id => iujptlRemove(id)"
                v-if="choosedIujptl.length > 0"
              />
            </div>

            <div class="col-wrapper__per-col">
              <div class="w-full mb16">
                <InputIcons
                  :title="'Klasifikasi INU BBM'"
                  :placeholder="'Cari klasifikasi INU BBM'"
                  :disabled="true"
                  :onClick="openInubbmModal"
                  :iconDisable="true"
                />
              </div>
              <ResultBar
                :data="choosedInubbm"
                :desc="'desc'"
                :onClick="id => inubbmRemove(id)"
                v-if="choosedInubbm.length > 0"
              />
            </div>
          </div>
          <div class="col-wrapper">
            <div class="col-wrapper__per-col">
              <div class="w-full mb16">
                <InputIcons
                  :title="'Klasifikasi SIUPAL'"
                  :placeholder="'Cari klasifikasi SIUPAL'"
                  :disabled="true"
                  :onClick="openSiupalModal"
                  :iconDisable="true"
                />
              </div>
              <ResultBar
                :data="choosedSiupal"
                :desc="'desc'"
                :onClick="id => siupalRemove(id)"
                v-if="choosedSiupal.length > 0"
              />
            </div>
            <div class="col-wrapper__per-col"></div>
          </div>

          <BtnIcons
            :className="'level1-section-filter__footer'"
            :path="'icon-search.png'"
            :title="'Tampilkan Filter'"
            :onClick="runSearch"
          />
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import ResultBar from './Organism/ResultBar.vue'

export default {
  props: ['status'],
  components: {
    InputIcons: () => import('@/components/Atoms/InputIcons'),
    Input: () => import('@/components/Atoms/Input'),
    FilterSio: () => import('@/components/Atoms/FilterSio'),
    FilterPertambangan: () => import('@/components/Atoms/FilterPertambangan'),
    FilterK3l: () => import('@/components/Atoms/FilterK3l'),
    FilterKplh: () => import('@/components/Atoms/FilterKplh'),
    BtnIcons: () => import('@/components/Atoms/BtnIcons'),
    ResultBar,
  },
  computed: {
    vendorName: {
      get: function() {
        return this.$store.state.searchStore.vendorName
      },
      set: function(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'vendorName',
          value: newValue,
        })
      },
    },
    location: {
      get() {
        return this.$store.state.searchStore.location
      },
      set(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'location',
          value: newValue,
        })
      },
    },
    choosedKbli: {
      get: function() {
        return this.$store.state.searchStore.choosedKbli
      },
    },
    choosedIujp: {
      get: function() {
        return this.$store.state.searchStore.choosedIujp
      },
    },
    choosedIujptl: {
      get: function() {
        return this.$store.state.searchStore.choosedIujptl
      },
    },
    choosedSbujk: {
      get: function() {
        return this.$store.state.searchStore.choosedSbujk
      },
    },
    choosedInubbm: {
      get: function() {
        return this.$store.state.searchStore.choosedInubbm
      },
    },
    choosedSiupal: {
      get: function() {
        return this.$store.state.searchStore.choosedSiupal
      },
    },
    chooseSio: {
      get: function() {
        return this.$store.state.searchStore.chooseSio
      },
    },
    chooseK3lScore() {
      return this.$store.state.searchStore.chooseK3lScore
    },
    chooseKplhScore() {
      return this.$store.state.searchStore.chooseKplhScore
    },
    chooseMine() {
      return this.$store.state.searchStore.chooseMine
    },
  },
  methods: {
    runFilter() {
      console.log('run filter => advance search')
    },
    onClose() {
      this.$store.commit('modalStore/closeModal', {
        name: 'advanceSearch',
      })
    },
    openKbliModal() {
      this.$store.commit('modalStore/openModal', {
        name: 'kbli',
      })
    },
    kbliRemove(id) {
      let data = this.$store.state.searchStore.choosedKbli

      let newData = data.filter(i => i.id != id)

      this.$store.commit('searchStore/SET_SEARCH_VALUE', {
        name: 'choosedKbli',
        value: newData,
      })
    },
    openIujpModal() {
      this.$store.commit('modalStore/openModal', {
        name: 'iujp',
      })
    },
    iujpRemove(id) {
      let data = this.$store.state.searchStore.choosedIujp

      let newData = data.filter(i => i.id != id)

      this.$store.commit('searchStore/SET_SEARCH_VALUE', {
        name: 'choosedIujp',
        value: newData,
      })
    },
    openSbujkModal() {
      this.$store.commit('modalStore/openModal', {
        name: 'sbujk',
      })
    },
    sbujkRemove(id) {
      let data = this.$store.state.searchStore.choosedSbujk

      let newData = data.filter(i => i.id != id)

      this.$store.commit('searchStore/SET_SEARCH_VALUE', {
        name: 'choosedSbujk',
        value: newData,
      })
    },
    openIujptlModal() {
      this.$store.commit('modalStore/openModal', {
        name: 'iujptl',
      })
    },
    iujptlRemove(id) {
      let data = this.$store.state.searchStore.choosedIujptl

      let newData = data.filter(i => i.id != id)

      this.$store.commit('searchStore/SET_SEARCH_VALUE', {
        name: 'choosedIujptl',
        value: newData,
      })
    },
    openInubbmModal() {
      this.$store.commit('modalStore/openModal', {
        name: 'inubbm',
      })
    },
    inubbmRemove(id) {
      let data = this.$store.state.searchStore.choosedInubbm

      let newData = data.filter(i => i.id != id)

      this.$store.commit('searchStore/SET_SEARCH_VALUE', {
        name: 'choosedInubbm',
        value: newData,
      })
    },
    openSiupalModal() {
      this.$store.commit('modalStore/openModal', {
        name: 'siupal',
      })
    },
    siupalRemove(id) {
      let data = this.$store.state.searchStore.choosedSiupal

      let newData = data.filter(i => i.id != id)

      this.$store.commit('searchStore/SET_SEARCH_VALUE', {
        name: 'choosedSiupal',
        value: newData,
      })
    },
    async runSearch() {
      let query = {
        vendorName:
          this.vendorName && this.vendorName !== ''
            ? `&search=${this.vendorName}`
            : '',
        location: this.location != '' ? `&location=${this.location}` : '',
        status: this.chooseStatus ? `&status=${this.chooseStatus}` : '',
        negara: this.choosedCountry
          ? `&negara_id=${this.choosedCountry.id}`
          : '',
        prov: this.choosedProvince
          ? `&provinsi_id=${this.choosedProvince.id}`
          : '',
        kota: this.choosedCity ? `&kota_id=${this.choosedCity.id}` : '',
        kec: this.choosedDistric
          ? `&kecamatan_id=${this.choosedDistric.id}`
          : '',
        kel: this.choosedVillage
          ? `&kelurahan_id=${this.choosedVillage.id}`
          : '',
        tambang: this.chooseMine ? `&pertambangan_inti=${this.chooseMine}` : '',
        sio: this.chooseSio ? `&sio=${this.chooseSio}` : '',
        k3l: this.chooseK3lScore.length > 0 ? '&k3l=1' : '',
        kplh: this.chooseKplhScore.length > 0 ? '&kplh=1' : '',
        poStart: this.poStartDate ? `&po_start_date=${this.poStartDate}` : '',
        poEnd: this.poEndDate ? `&po_end_date=${this.poEndDate}` : '',
        eventStart: this.eventStartDate
          ? `&event_start_date=${this.eventStartDate}`
          : '',
        eventEnd: this.eventEndDate
          ? `&event_end_date=${this.eventEndDate}`
          : '',
        spmStart: this.spmStartDate
          ? `&spm_start_date=${this.spmStartDate}`
          : '',
        spmEnd: this.spmEndDate ? `&spm_end_date=${this.spmEndDate}` : '',
        sioStart:
          this.chooseSio == 1 && this.sioStartDate
            ? `&sio_start_date=${this.sioStartDate}`
            : '',
        sioEnd:
          this.chooseSio == 1 && this.sioEndDate
            ? `&sio_end_date=${this.sioEndDate}`
            : '',
        k3lStart:
          this.choosePraqualifikasiK3l && this.k3lStartDate
            ? `&k3l_end_date=${this.k3lStartDate}`
            : '',
        k3lEnd:
          this.choosePraqualifikasiK3l && this.k3lEndDate
            ? `&k3l_end_date=${this.k3lEndDate}`
            : '',
        kplhStart:
          this.choosePraqualifikasiKplh && this.kplhStartDate
            ? `&kplh_end_date=${this.kplhStartDate}`
            : '',
        kplhEnd:
          this.choosePraqualifikasiKplh && this.kplhEndDate
            ? `&kplh_end_date=${this.kplhEndDate}`
            : '',
        gradeStart: this.spmScoreStart
          ? `&grade_start=${this.spmScoreStart}`
          : '',
        gradeEnd: this.spmScoreEnd ? `&grade_end=${this.spmScoreEnd}` : '',
        csiStart: this.poScoreStart ? `&csi_start=${this.poScoreStart}` : '',
        csiEnd: this.poScoreEnd ? `&csi_end=${this.poScoreEnd}` : '',
        k3lScore:
          this.chooseK3lScore.length > 0
            ? this.paramsFormatter('k3l_score', this.chooseK3lScore)
            : '',
        kplhScore:
          this.chooseKplhScore.length > 0
            ? this.paramsFormatter('kplh_score', this.chooseKplhScore)
            : '',
        kbliSub:
          this.choosedKbli && this.choosedKbli.length > 0
            ? this.paramsFormatter(
                'kbli_sub',
                this.choosedKbli.map(item => {
                  return item.id
                })
              )
            : '',
        iujp:
          this.choosedIujp && this.choosedIujp.length > 0
            ? this.paramsFormatter(
                'iujp',
                this.choosedIujp.map(item => {
                  return item.id
                })
              )
            : '',
        iujptl:
          this.choosedIujptl && this.choosedIujptl.length > 0
            ? this.paramsFormatter(
                'iujptl',
                this.choosedIujptl.map(item => {
                  return item.id
                })
              )
            : '',
        sbujk:
          this.choosedSbujk && this.choosedSbujk.length > 0
            ? this.paramsFormatter(
                'sbujk',
                this.choosedSbujk.map(item => {
                  return item.id
                })
              )
            : '',
        inubbm:
          this.choosedInubbm && this.choosedInubbm.length > 0
            ? this.paramsFormatter(
                'inubbm',
                this.choosedInubbm.map(item => {
                  return item.id
                })
              )
            : '',
        siupal:
          this.choosedSiupal && this.choosedSiupal.length > 0
            ? this.paramsFormatter(
                'siupal',
                this.choosedSiupal.map(item => {
                  return item.id
                })
              )
            : '',
      }

      console.log('query: ', query)

      // await this.$store.commit('modalStore/SET_MODAL_LEVEL1', false)
      await this.$store.commit('level1/GET_VENDOR', { query })
      await this.$store.commit('modalStore/closeModal', {
        name: 'advanceSearch',
      })

      if (this.$route.path !== '/search-result') {
        await this.$router.push('search-result')
      }
    },
  },
}
</script>
